module.exports = __webpack_public_path__ + "img/picture.a3bd41dd.jpg";